"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useListenForTransportEvent = void 0;

var _react = require("react");

var useListenForTransportEvent = function useListenForTransportEvent(_ref) {
  var transport = _ref.transport,
      createTrackEvent = _ref.createTrackEvent;
  (0, _react.useEffect)(function () {
    if (!transport) {
      return;
    }

    transport.listen({
      id: "websocket-delivery-listener",
      type: "message",
      listener: function listener(courierEvent) {
        var _courierData$tracking;

        var courierMessage = courierEvent === null || courierEvent === void 0 ? void 0 : courierEvent.data;
        var courierData = courierMessage === null || courierMessage === void 0 ? void 0 : courierMessage.data;

        if (courierData !== null && courierData !== void 0 && (_courierData$tracking = courierData.trackingIds) !== null && _courierData$tracking !== void 0 && _courierData$tracking.deliverTrackingId) {
          var _courierData$tracking2;

          createTrackEvent(courierData === null || courierData === void 0 ? void 0 : (_courierData$tracking2 = courierData.trackingIds) === null || _courierData$tracking2 === void 0 ? void 0 : _courierData$tracking2.deliverTrackingId);
        }
      }
    });
  }, [createTrackEvent, transport]);
};

exports.useListenForTransportEvent = useListenForTransportEvent;